import React from 'react';
import { Link } from 'react-router-dom';
import { servicesData } from '../data/services';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Services = () => {
  const { t } = useTranslation();

  return (
    <div className="pt-10">
      <section className="bg-dark-green py-24 text-white relative overflow-hidden text-center">
        <div className="absolute top-0 left-0 w-full h-full opacity-10">
          <img src="/assets/images/ChatGPT Image Jun 5, 2026, 05_33_14 PM.png" alt="Background" className="w-full h-full object-cover" />
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <h1 className="text-4xl md:text-6xl font-extrabold mb-6 tracking-tight">{t('services.header.title')}</h1>
          <p className="text-xl text-gold-light max-w-3xl mx-auto leading-relaxed">
            {t('services.header.subtitle')}
          </p>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="space-y-32">
            {Object.entries(servicesData).map(([key, section], index) => (
              <div key={key} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-16 items-center`}>
                {/* Image Side */}
                <div className="lg:w-1/2 relative group">
                  <div className="absolute -inset-4 bg-gold-primary/10 rounded-[2rem] blur-2xl group-hover:bg-gold-primary/20 transition-all duration-500"></div>
                  <div className="relative rounded-[2rem] overflow-hidden shadow-2xl border-4 border-white aspect-[16/10]">
                    <img 
                      src={section.image} 
                      alt={t(`services.categories.${key}.title`)} 
                      className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-dark-green/10 group-hover:bg-transparent transition-colors duration-500"></div>
                  </div>
                </div>

                {/* Content Side */}
                <div className="lg:w-1/2 space-y-8">
                  <div className="inline-flex items-center gap-4 bg-cream-off px-6 py-3 rounded-2xl border border-gold-light/30 shadow-sm">
                    {React.cloneElement(section.icon, { size: 32 })}
                    <span className="text-dark-green font-bold tracking-widest uppercase text-sm">Service Category</span>
                  </div>
                  
                  <h2 className="text-4xl font-extrabold text-dark-green tracking-tight">{t(`services.categories.${key}.title`)}</h2>
                  <p className="text-lg text-gray-600 leading-relaxed border-l-4 border-gold-primary pl-6 py-2 italic">
                    {t(`services.categories.${key}.description`)}
                  </p>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {Object.entries(t(`services.categories.${key}.items`, { returnObjects: true })).slice(0, 4).map(([itemKey, item], i) => (
                      <div key={i} className="flex items-center gap-3 text-gray-700 font-medium">
                        <CheckCircle2 size={18} className="text-gold-primary" />
                        <span>{item.name}</span>
                      </div>
                    ))}
                  </div>

                  <div className="pt-6 flex flex-wrap gap-4">
                    <Link 
                      to={`/services/${key}`} 
                      className="inline-flex items-center space-x-3 bg-dark-green text-white px-8 py-4 rounded-xl font-bold hover:bg-dark-green-deep transition-all shadow-lg hover:-translate-y-1"
                    >
                      <span>Learn More</span>
                      <ArrowRight size={20} />
                    </Link>
                    <Link 
                      to="/enquiry" 
                      className="inline-flex items-center space-x-3 border-2 border-gold-primary text-gold-primary px-8 py-4 rounded-xl font-bold hover:bg-gold-primary hover:text-white transition-all shadow-md"
                    >
                      <span>{t('services.applyNow')}</span>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-dark-green-deep text-white relative overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 bg-gold-primary/5 rounded-full blur-3xl -mr-48 -mt-48"></div>
        <div className="container mx-auto px-4 text-center relative z-10">
          <h2 className="text-4xl font-bold mb-8">{t('services.cta.title')}</h2>
          <p className="text-xl text-gold-light mb-12 max-w-2xl mx-auto">
            {t('services.cta.subtitle')}
          </p>
          <div className="flex flex-wrap justify-center gap-6">
            <Link to="/contact" className="bg-white text-dark-green px-12 py-4 rounded-2xl font-bold hover:bg-gold-light transition-all shadow-xl hover:-translate-y-1">
              {t('nav.contact')}
            </Link>
            <Link to="/enquiry" className="bg-gold-primary text-white px-12 py-4 rounded-2xl font-bold hover:bg-gold-primary/90 transition-all shadow-xl hover:-translate-y-1">
              {t('services.cta.book')}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
